import type { CSSProperties } from "react";

export type PlaceholderKind = "light" | "dark" | "gold";

interface PlaceholderProps {
  label: string;
  kind?: PlaceholderKind;
  aspect?: string;
  className?: string;
  style?: CSSProperties;
}

/** Intentional design placeholder used everywhere images would go. */
export function Placeholder({
  label,
  kind = "light",
  aspect = "4/3",
  className = "",
  style = {},
}: PlaceholderProps) {
  const cls = ["ph", kind === "dark" ? "ph-dark" : kind === "gold" ? "ph-gold" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} style={{ aspectRatio: aspect, ...style }}>
      <span className="label">{label}</span>
    </div>
  );
}
